<ng-template #button let-ticket="ticket" let-journey="journey" let-ticketType="ticketType">
  <div
    class="other-icons-top"
    [ngClass]="{
      'other-icons-top-realign':
        (ticket.officePreferred || ticket.companyPreferred || ticket.identifiers?.isSplit) &&
        ticket.availableSeats &&
        ticket.availableSeats < 9
    }"
  >
    @if (ticket.availableSeats && ticket.availableSeats < 9) {
      <div class="available-seats" id="remainingSeats">
        {{ ticket.availableSeats }} <span i18n="@@railSeatsLeft">Seats Left</span>
      </div>
    }
    <div class="flex-row-container">
      <div class="white-theme">
        <app-preferred-icons
          [tmcPreferred]="ticket.tmcPreferred"
          [tmcPreferredLogoUrl]="ticket.tmcPreferredLogoUrl"
          [tmcPreferredMessage]="ticket.tmcPreferredMessage"
          [clientPreferred]="ticket.officePreferred || ticket.companyPreferred"
          [companyPreferredMessage]="ticket.companyPreferredMessage"
          [officePreferredMessage]="ticket.officePreferredMessage"
        >
        </app-preferred-icons>
      </div>
      @if (ticket.identifiers?.isSplit) {
        <section class="container">
          <span>
            <app-split-ticket-icon
              [savings]="ticketSavings[ticket.fareHash]"
              [currency]="ticket.currency"
              [ngbTooltip]="
                'Split Ticket – This ticket will purchase multiple tickets to cover your journey' +
                (splitSavings(ticket) && +splitSavings(ticket) > 0
                  ? ', saving ' +
                    (splitSavings(ticket) | currency: ticket.currency : 'symbol' : '1.2-2') +
                    ' against the next available fare of the same ticket type.'
                  : '')
              "
              placement="top"
            >
            </app-split-ticket-icon>
          </span>
        </section>
      }
    </div>
  </div>
  <div class="td_button_container">
    <section class="container" (mouseleave)="buttonTt.close()">
      <ng-template #tooltipTemplate>
        @if (ticket.selectable) {
          <div>{{ ticket.type?.replace(',', ', ') }}</div>
          <div>
            <a
              (click)="openRailTicketDetailsDialog(journey, ticket)"
              (keyup.enter)="openRailTicketDetailsDialog(journey, ticket)"
              (keyup.space)="openRailTicketDetailsDialog(journey, ticket); $event.preventDefault()"
              i18n="@@railViewConditions"
              class="view_conditions"
              tabindex="0"
              (blur)="checkTooltipFocus(buttonTt)"
              role="button"
              attr.aria-label="View conditions for {{ ticket.type?.replace(',', ', ') }}"
              >View Conditions</a
            >
          </div>
        }
        @if (!ticket.selectable) {
          <span i18n="@@railresultsUnavailable">Unavailable</span>
        }
      </ng-template>
      <button
        [ngbTooltip]="tooltipTemplate"
        tooltipClass="button_tooltip"
        triggers="manual"
        #buttonTt="ngbTooltip"
        (focus)="buttonTt.open()"
        (blur)="checkTooltipFocus(buttonTt)"
        (mouseenter)="buttonTt.open()"
        [ngClass]="[
          ticket.selected ? 'selected-price' : 'notselected',
          direction + '-' + ticket.price,
          direction + '-' + ticket.class + '-' + ticket.price,
          (ticketType === RailFareTypes.returnJourneyFares ||
            ticketType === RailFareTypes.splitFares) &&
          searchParams.selectedTicket &&
          direction === RailDirection.Inbound
            ? 'selectable_return'
            : '',
          ticketType === RailFareTypes.splitFares ? 'split_border' : ''
        ]"
        class="rail-price"
        id="{{ !!ticket.class ? direction + '-' + ticket.class : direction + '-' + 'No ticket' }}"
        (click)="onSelectTicket(journey, ticket, ticketType)"
        (contextmenu)="
          ticket.selectable ? openRailTicketDetailsDialog(journey, ticket) : null;
          $event.preventDefault()
        "
        (keydown.shift.f10)="
          ticket.selectable ? openRailTicketDetailsDialog(journey, ticket) : null
        "
        mat-button
        color="accent"
        [disabled]="!ticket.selectable"
        attr.aria-label="{{
          (searchParams.chosenSearchType === RailSearchJourneyType.ReturnJourney &&
          this.direction === RailDirection.Inbound &&
          !searchParams.chosenSearchType.selectedTicket
            ? '-'
            : '') +
            direction ===
          RailDirection.Outbound
            ? 'Outbound'
            : 'Inbound'
        }}
        {{ ticket.identifiers?.isSplit ? 'split ticket' : '' }}
        {{ ticket.price | currency: ticket.currency }} {{ ticket.type | titlecase }}{{
          ticket.selected ? ' selected' : ''
        }}. Departing {{ journey.from }} at
        {{ journey.departDateTime | sabsTimePipe }} arriving at {{ journey.to }} at {{
          journey.arriveDateTime | sabsTimePipe
        }}. Right-click or Shift+F10 to view conditions."
        [attr.aria-pressed]="ticket.selected"
        aria-live="polite"
      >
        @if (
          ticketType !== RailFareTypes.returnJourneyFares ||
          !searchParams.selectedTicket ||
          direction !== RailDirection.Inbound
        ) {
          {{
            ticket.price === undefined
              ? ''
              : direction === RailDirection.Inbound &&
                  (ticketType === RailFareTypes.returnJourneyFares ||
                    ticketType === RailFareTypes.splitFares)
                ? '-'
                : (ticket.price | currency: ticket.currency || '')
          }}
        }
        @if (
          (ticketType === RailFareTypes.returnJourneyFares ||
            ticketType === RailFareTypes.splitFares) &&
          searchParams.selectedTicket &&
          direction === RailDirection.Inbound
        ) {
          <div class="basket">
            <span class="counter">+</span>
            <img
              class="cart"
              [ngClass]="{ split_icon: ticketType === RailFareTypes.splitFares }"
              src="https://images.sabscorp.com/images/enterprise/lightUK/assets/images/empty-cart.svg"
              alt="Cart"
            />
          </div>
        }
      </button>
    </section>
    <section class="container" (mouseleave)="expandTt.close()">
      <button
        class="more_tickets_button"
        ngbTooltip="Expand for more fares"
        tooltipClass="button_tooltip"
        triggers="manual"
        #expandTt="ngbTooltip"
        id="more_tickets_button_{{
          !!ticket.class ? direction + '-' + ticket.class : direction + '-' + 'No ticket'
        }}"
        i18n-ngbTooltip
        (focus)="expandTt.open()"
        (blur)="expandTt.close()"
        (mouseenter)="expandTt.open()"
        (click)="openTicketsOfTheSameType(journey, ticket)"
        [disabled]="!ticket.selectable"
        [hidden]="
          direction === RailDirection.Inbound &&
          (ticketType === RailFareTypes.returnJourneyFares ||
            ticketType === RailFareTypes.splitFares)
        "
        attr.aria-label="Open more ticket types for {{ ticket.type | titlecase }}{{
          ticket.selected ? ' selected' : ''
        }}. Departing {{ journey.from }} at
              {{ journey.departDateTime | sabsTimePipe }} arriving at {{ journey.to }} at {{
          journey.arriveDateTime | sabsTimePipe
        }}"
      >
        +
      </button>
    </section>
  </div>
  <div class="other-icons-container">
    <app-warning-tags [iconId]="ticket.fareHash" [ticket]="ticket"></app-warning-tags>
    @if (isGroupFare(ticket)) {
      <section class="container">
        @switch (sourceName) {
          @case (ServiceProvider.Evolvi) {
            <div (mouseleave)="tt10.close()">
              <img
                src="https://images.sabscorp.com/images/GroupDiscount.gif"
                ngbTooltip="Group ticket - to qualify for this fare all travellers must travel together on the same ticket"
                alt="Group ticket"
                class="ico-float-left"
                tabindex="0"
                triggers="manual"
                #tt10="ngbTooltip"
                (mouseenter)="tt10.open()"
                (focus)="tt10.open()"
                (blur)="tt10.close()"
              />
            </div>
          }
          @case (ServiceProvider.Trainline) {
            <div (mouseleave)="tt10.close()">
              <span
                ngbTooltip="GroupSave discount applied. All passengers must travel together"
                class="ico-tl-group-save"
                triggers="manual"
                #tt10="ngbTooltip"
                tabindex="0"
                (mouseenter)="tt10.open()"
                (focus)="tt10.open()"
                (blur)="tt10.close()"
                >GroupSave</span
              >
            </div>
          }
        }
      </section>
    }
  </div>
</ng-template>

<ng-template #disabled_button let-ticket="ticket" let-journey="journey" let-ticketType="ticketType">
  <div class="other-icons-top">
    <div class="flex-row-container">
      <div class="white-theme">
        <app-preferred-icons
          [tmcPreferred]="ticket.tmcPreferred"
          [tmcPreferredLogoUrl]="ticket.tmcPreferredLogoUrl"
          [tmcPreferredMessage]="ticket.tmcPreferredMessage"
          [clientPreferred]="ticket.officePreferred || ticket.companyPreferred"
          [companyPreferredMessage]="ticket.companyPreferredMessage"
          [officePreferredMessage]="ticket.officePreferredMessage"
        >
        </app-preferred-icons>
      </div>
      @if (ticket.identifiers?.isSplit) {
        <section class="container">
          <span>
            <app-split-ticket-icon
              [savings]="ticketSavings[ticket.fareHash]"
              [currency]="ticket.currency"
              [ngbTooltip]="
                'Split Ticket – This ticket will purchase multiple tickets to cover your journey' +
                (splitSavings(ticket) && +splitSavings(ticket) > 0
                  ? ', saving ' +
                    (splitSavings(ticket) | currency: ticket.currency : 'symbol' : '1.2-2') +
                    ' against the next available fare of the same ticket type.'
                  : '')
              "
              placement="top"
            >
            </app-split-ticket-icon>
          </span>
        </section>
      }
    </div>
  </div>
  <div class="td_button_container">
    <section class="container" (mouseleave)="unavailableTt.close()">
      <span
        [ngClass]="[
          ticket.selected ? 'selected-price' : 'notselected',
          direction + '-' + ticket.price,
          direction + '-' + ticket.class + '-' + ticket.price
        ]"
        aria-hidden="true"
        class="rail-price rail-no"
        id="{{ !!ticket.class ? direction + '-' + ticket.class : direction + '-no-ticket' }}"
        [ngbTooltip]="
          ticket.unavailable ? 'Fare is unavailable due to being out of policy' : 'Unavailable'
        "
        tooltipClass="unavailable_tooltip"
        i18n-ngbTooltip
        triggers="manual"
        #unavailableTt="ngbTooltip"
        (focus)="unavailableTt.open()"
        (blur)="unavailableTt.close()"
        (mouseenter)="unavailableTt.open()"
        tabindex="0"
      >
        {{
          ticket.price === undefined
            ? ''
            : direction === RailDirection.Inbound &&
                (ticketType === RailFareTypes.returnJourneyFares ||
                  ticketType === RailFareTypes.splitFares)
              ? '-'
              : (ticket.price | currency: ticket.currency || '')
        }}
      </span>
    </section>
    <section class="container" (mouseleave)="expandTt.close()">
      <button
        class="more_tickets_button"
        ngbTooltip="Expand for more fares"
        tooltipClass="button_tooltip"
        triggers="manual"
        #expandTt="ngbTooltip"
        id="more_tickets_button_{{
          !!ticket.class ? direction + '-' + ticket.class : direction + '-' + 'No ticket'
        }}"
        i18n-ngbTooltip
        (focus)="expandTt.open()"
        (blur)="expandTt.close()"
        (mouseenter)="expandTt.open()"
        (click)="openTicketsOfTheSameType(journey, ticket)"
        [disabled]="!ticket.selectable"
        [hidden]="
          direction === RailDirection.Inbound &&
          (ticketType === RailFareTypes.returnJourneyFares ||
            ticketType === RailFareTypes.splitFares)
        "
        attr.aria-label="Open more ticket types for {{ ticket.type | titlecase }}{{
          ticket.selected ? ' selected' : ''
        }}. Departing {{ journey.from }} at
              {{ journey.departDateTime | sabsTimePipe }} arriving at {{ journey.to }} at {{
          journey.arriveDateTime | sabsTimePipe
        }}"
      >
        +
      </button>
    </section>
  </div>
  <div class="other-icons-container">
    <app-warning-tags [iconId]="ticket.fareHash" [ticket]="ticket"></app-warning-tags>
    @if (isGroupFare(ticket)) {
      <section class="container">
        @switch (sourceName) {
          @case (ServiceProvider.Evolvi) {
            <div (mouseleave)="tt10.close()">
              <img
                src="https://images.sabscorp.com/images/GroupDiscount.gif"
                ngbTooltip="Group ticket - to qualify for this fare all travellers must travel together on the same ticket"
                alt="Group ticket"
                class="ico-float-left"
                tabindex="0"
                triggers="manual"
                #tt10="ngbTooltip"
                (mouseenter)="tt10.open()"
                (focus)="tt10.open()"
                (blur)="tt10.close()"
              />
            </div>
          }
          @case (ServiceProvider.Trainline) {
            <div (mouseleave)="tt10.close()">
              <span
                ngbTooltip="GroupSave discount applied. All passengers must travel together"
                class="ico-tl-group-save"
                triggers="manual"
                #tt10="ngbTooltip"
                tabindex="0"
                (mouseenter)="tt10.open()"
                (focus)="tt10.open()"
                (blur)="tt10.close()"
                >GroupSave</span
              >
            </div>
          }
        }
      </section>
    }
  </div>
</ng-template>

<ng-template
  #incompatible_button
  let-ticket="ticket"
  let-journey="journey"
  let-ticketType="ticketType"
>
  <div class="other-icons-top">
    <div class="white-theme">
      <app-preferred-icons
        [tmcPreferred]="ticket.tmcPreferred"
        [tmcPreferredLogoUrl]="ticket.tmcPreferredLogoUrl"
        [tmcPreferredMessage]="ticket.tmcPreferredMessage"
        [clientPreferred]="ticket.officePreferred || ticket.companyPreferred"
        [companyPreferredMessage]="ticket.companyPreferredMessage"
        [officePreferredMessage]="ticket.officePreferredMessage"
      >
      </app-preferred-icons>
    </div>
    @if (ticket.identifiers?.isSplit) {
      <section class="container">
        <span>
          <app-split-ticket-icon
            [savings]="ticketSavings[ticket.fareHash]"
            [currency]="ticket.currency"
            [ngbTooltip]="
              'Split Ticket – This ticket will purchase multiple tickets to cover your journey' +
              (splitSavings(ticket) && +splitSavings(ticket) > 0
                ? ', saving ' +
                  (splitSavings(ticket) | currency: ticket.currency : 'symbol' : '1.2-2') +
                  ' against the next available fare of the same ticket type.'
                : '')
            "
            placement="top"
          >
          </app-split-ticket-icon>
        </span>
      </section>
    }
  </div>
  <div class="td_button_container">
    <section class="container" (mouseleave)="ttUnavailableText.close()">
      <span
        [ngClass]="[
          ticket.selected ? 'selected-price' : 'notselected',
          direction + '-' + ticket.price,
          direction + '-' + ticket.class + '-' + ticket.price
        ]"
        class="rail-price rail-no"
        id="{{
          (!!ticket.class ? direction + '-' + ticket.class : direction + '-no-ticket') +
            (ticketType === RailFareTypes.returnJourneyFares
              ? '-return-journey'
              : ticketType === RailFareTypes.splitFares
                ? '-split-fares'
                : '')
        }}"
        ngbTooltip="Invalid Selection: you cannot select a time that leaves before the departing journey has arrived, please choose an alternative."
        i18n-ngbTooltip
        #ttUnavailableText="ngbTooltip"
        triggers="manual"
        (mouseenter)="ttUnavailableText.open()"
      >
        <!--Don't need tabindex/focus/blur here for the tooltip, this is for sighted mouse users only, icon below is for SR/keyboard users-->
        {{
          ticket.price === undefined
            ? ''
            : direction === RailDirection.Inbound &&
                (ticketType === RailFareTypes.returnJourneyFares ||
                  ticketType === RailFareTypes.splitFares)
              ? '-'
              : (ticket.price | currency: ticket.currency || '')
        }}
      </span>
    </section>
    <section class="container" (mouseleave)="expandTt.close()">
      <button
        class="more_tickets_button"
        ngbTooltip="Expand for more fares"
        triggers="manual"
        #expandTt="ngbTooltip"
        id="more_tickets_button_{{
          !!ticket.class ? direction + '-' + ticket.class : direction + '-' + 'No ticket'
        }}"
        i18n-ngbTooltip
        (focus)="expandTt.open()"
        (blur)="expandTt.close()"
        (mouseenter)="expandTt.open()"
        (click)="openTicketsOfTheSameType(journey, ticket)"
        disabled="true"
        [hidden]="
          direction === RailDirection.Inbound &&
          (ticketType === RailFareTypes.returnJourneyFares ||
            ticketType === RailFareTypes.splitFares)
        "
        attr.aria-label="Open more ticket types for {{ ticket.type | titlecase }}{{
          ticket.selected ? ' selected' : ''
        }}. Departing {{ journey.from }} at
              {{ journey.departDateTime | sabsTimePipe }} arriving at {{ journey.to }} at {{
          journey.arriveDateTime | sabsTimePipe
        }}"
      >
        +
      </button>
    </section>
  </div>
  <div class="other-icons-container">
    <section (mouseleave)="ttUnavailableIcon.close()" class="container">
      <fa-icon
        class="time_error_icon"
        container="body"
        triggers="manual"
        #ttUnavailableIcon="ngbTooltip"
        (mouseenter)="ttUnavailableIcon.open()"
        ngbTooltip="Invalid Selection: you cannot select a time that leaves before the departing journey has arrived, please choose an alternative."
        i18n-ngbTooltip
        attr.aria-label="Invalid Selection: you cannot select a time that leaves before the departing journey has arrived, please choose an alternative."
        (focus)="ttUnavailableIcon.open()"
        (blur)="ttUnavailableIcon.close()"
        tabindex="0"
        [icon]="faCalendarExclamation"
      />
      <span class="visuallyhidden">
        Invalid Selection: you cannot select a time that leaves before the departing journey has
        arrived, please choose an alternative.
      </span>
    </section>
  </div>
</ng-template>

<span class="visuallyhidden" role="alert">{{ getHiddenText() }}</span>

<div class="time-row">
  @if (!isExchange) {
    <button
      appButton="small"
      class="small-button--margin earlier_rail_times previous_day"
      (click)="prevDay.emit()"
      i18n-aria-label
      id="rail-results-button-previous-day-{{
        direction === RailDirection.Outbound ? 'outbound' : 'inbound'
      }}"
      attr.aria-label="Previous Day Rail Times {{
        direction === RailDirection.Outbound ? 'outbound' : 'inbound'
      }}"
    >
      <i class="ico-chevron-left" aria-hidden="true"></i>
      <span i18n="@@railPreviousDay">Previous Day</span>
    </button>
  }
  @if (!hidePagination) {
    <button
      appButton="small"
      class="small-button--margin earlier_rail_times"
      (click)="earlier.emit(isDateDifferent)"
      i18n-aria-label
      id="rail-results-button-earlier-{{
        direction === RailDirection.Outbound ? 'outbound' : 'inbound'
      }}"
      attr.aria-label="Earlier Rail Times {{
        direction === RailDirection.Outbound ? 'outbound' : 'inbound'
      }}"
    >
      <i class="ico-chevron-left" aria-hidden="true"></i>
      <span i18n="@@railEarlier">Earlier</span>
    </button>
  }
  <span
    id="travel-date-{{ direction === RailDirection.Outbound ? 'outbound' : 'inbound' }}"
    class="date_title"
    >{{ journeys[0]?.departDateTime | sabsDate: 1 }}
  </span>
  @if (!hidePagination) {
    <button
      appButton="small"
      class="small-button--margin later_rail_times"
      (click)="later.emit()"
      i18n-aria-label
      id="rail-results-button-later-{{
        direction === RailDirection.Outbound ? 'outbound' : 'inbound'
      }}"
      attr.aria-label="Later Rail Times {{
        direction === RailDirection.Outbound ? 'outbound' : 'inbound'
      }}"
    >
      <span i18n="@@railLater">Later</span>
      <i class="ico-chevron-right" aria-hidden="true"></i>
    </button>
  }
  @if (!isExchange) {
    <button
      appButton="small"
      class="small-button--margin later_rail_times next_day"
      (click)="nextDay.emit()"
      i18n-aria-label
      id="rail-results-button-next-day-{{
        direction === RailDirection.Outbound ? 'outbound' : 'inbound'
      }}"
      attr.aria-label="Next Day Rail Times {{
        direction === RailDirection.Outbound ? 'outbound' : 'inbound'
      }}"
    >
      <span i18n="@@railNextDay">Next Day</span>
      <i class="ico-chevron-right" aria-hidden="true"></i>
    </button>
  }
</div>
<table class="rail_results_table">
  <tr class="header_row">
    <!--Headers-->
    <th i18n="@@railJourneyInfo">Journey&#10;Information</th>
    <th i18n="@@railDepartArrive" id="journeyTimes" class="pc_display">Departure /&#10;Arrival</th>
    <th i18n="@@railCarbonEmissions" id="journeyC02" class="pc_display">
      Carbon&#10;Emissions (kg)
    </th>
    <th i18n="@@railAdditionalInformation" id="journeyExtraInfo" class="pc_display">
      Additional&#10;Information
    </th>
    @if (displayStandardSingles) {
      <th i18n="@@railStandardSingles" id="journeyStandardSingle">Standard&#10;Singles</th>
    }
    @if (displayFirstClassSingles) {
      <th i18n="@@railFirstClassSingles" id="journeyFirstClassSingles">1st Class&#10;Singles</th>
    }
    @if (displayStandardReturns) {
      <th i18n="@@railStandardReturns" id="journeyStandardReturn">Standard&#10;Returns</th>
    }
    @if (displayFirstClassReturns) {
      <th i18n="@@railFirstClassReturns" id="journeyFirstClassReturn">1st Class&#10;Returns</th>
    }
  </tr>
  <tbody>
    @for (journey of journeys; track trackRowFunction($index, journey)) {
      <tr
        [ngClass]="{
          selected_row:
            newResultsObject.standardSingles[journey.journeyHash]?.selected ||
            newResultsObject.standardReturns[journey.journeyHash]?.selected ||
            newResultsObject.firstClassSingles[journey.journeyHash]?.selected ||
            newResultsObject.firstClassSingles[journey.journeyHash]?.selected,
          cancelled_text: journey.cancelled,
          low_co2_row: journey.co2PerPassenger === lowestCarbonValue
        }"
      >
        <td class="header_column">
          <div class="table_header_container">
            <div id="{{ direction }}_from_station" class="table_header_main">
              {{ journey.from }}
            </div>
            <div
              id="{{ direction }}_departure_time"
              class="table_header_main mobile_display mobile_margin-bottom"
            >
              {{ journey.departDateTime | sabsTimePipe }}
              @if (datesAfterInitial[i]) {
                <section class="container" (mouseleave)="ttp1.close()">
                  <div
                    class="plus_one"
                    i18n-ngbTooltip
                    ngbTooltip="Departure date is next day."
                    tooltipClass="button_tooltip"
                    #ttp1="ngbTooltip"
                    (mouseenter)="ttp1.open()"
                    (focus)="ttp1.open()"
                    (blur)="ttp1.close()"
                    tabindex="0"
                  >
                    +1
                  </div>
                </section>
              }
            </div>
            <div id="{{ direction }}_travel_time" class="small_text">
              {{ journeyTime | memoize: journey.departDateTime : journey.arriveDateTime }}
            </div>
            <div class="flex-row-container changes_container mobile_display">
              @if (convertChangesToNumber(journey.changes) > 0) {
                <div id="{{ direction }}_changes" class="small_text">
                  {{ journey.changes }}&nbsp;
                  @if (convertChangesToNumber(journey.changes) > 1) {
                    <span i18n="@@railResultsBlockChanges">changes</span>
                  }
                  @if (convertChangesToNumber(journey.changes) === 1) {
                    <span i18n="@@railResultsBlockChange">change</span>
                  }
                </div>
              }
              @if (convertChangesToNumber(journey.changes) === 0) {
                <div class="small_text" i18n="@@railResultsBlockDirect">Direct</div>
              }
              <button
                id="further_details_button"
                class="details_button"
                (click)="openDetailsModal(journey)"
              >
                <i class="currency_info_icon"></i>
              </button>
            </div>
            <div class="mobile_display small_text">
              {{ journey.co2PerPassenger }} kg CO2
              @if (journey.co2PerPassenger === lowestCarbonValue) {
                <img
                  class="greenerChoiceLogo"
                  src="https://images.sabscorp.com/images/logo/seedling.svg"
                  alt="Greener Choice"
                />
              }
            </div>
            <div class="flex-column-container mobile_display other_info_mobile">
              @if (busyTimes[journey.journeyHash]) {
                <section (mouseleave)="ttb.close()" class="container">
                  <img
                    src="https://images.sabscorp.com/images/enterprise/lightUK/assets/png/busy_train.png"
                    alt="This service is predicted to be busy."
                    class="busy_train"
                    #ttb="ngbTooltip"
                    (mouseenter)="ttb.open()"
                    triggers="manual"
                    (focus)="ttb.open()"
                    (blur)="ttb.close()"
                    tabindex="0"
                    ngbTooltip="This service is predicted to be busy."
                    tooltipClass="button_tooltip"
                    i18n-ngbTooltip
                  />
                </section>
              }
              @if (checkForBus(journey)) {
                <section (mouseleave)="ttbus.close()" class="container">
                  <i
                    class="ico-bus replacement_bus"
                    alt="This is a bus replacement service."
                    #ttbus="ngbTooltip"
                    (mouseenter)="ttbus.open()"
                    triggers="manual"
                    (focus)="ttbus.open()"
                    (blur)="ttbus.close()"
                    tabindex="0"
                    ngbTooltip="This is a bus replacement service."
                    tooltipClass="button_tooltip"
                    i18n-ngbTooltip
                  ></i>
                </section>
              }
              @if (journey.overtaken) {
                <span class="overtaken" i18n="@@railresultsheaderOvertaken">Overtaken </span>
              }
              @if (journey.cancelled) {
                <span class="cancelled" i18n="@@railresultsheaderCancelled"
                  >Service Cancelled
                </span>
              }
              @if (
                !busyTimes[journey.journeyHash] &&
                !checkForBus(journey) &&
                !journey.overtaken &&
                !journey.cancelled
              ) {
                <span class="visuallyhidden"> No additional information available </span>
              }
            </div>
            <div id="{{ direction }}_to_station" class="table_header_main mobile_margin-top">
              {{ journey.to }}
            </div>
            <div id="{{ direction }}_arrival_time" class="table_header_main mobile_display">
              {{ journey.arriveDateTime | sabsTimePipe }}
            </div>
          </div>
        </td>
        <td class="pc_display header_column">
          <div class="table_header_container">
            <div id="{{ direction }}_departure_time" class="flex-row-container table_header_main">
              {{ journey.departDateTime | sabsTimePipe }}
              @if (datesAfterInitial[i]) {
                <section class="container" (mouseleave)="ttp2.close()">
                  <div
                    class="plus_one"
                    i18n-ngbTooltip
                    ngbTooltip="Departure date is next day."
                    tooltipClass="button_tooltip"
                    #ttp2="ngbTooltip"
                    (mouseenter)="ttp2.open()"
                    (focus)="ttp2.open()"
                    (blur)="ttp2.close()"
                    tabindex="0"
                  >
                    +1
                  </div>
                </section>
              }
            </div>
            <div class="flex-row-container changes_container">
              @if (convertChangesToNumber(journey.changes) > 0) {
                <div id="{{ direction }}_changes" class="small_text">
                  {{ journey.changes }}&nbsp;
                  @if (convertChangesToNumber(journey.changes) > 1) {
                    <span i18n="@@railResultsBlockChanges">changes</span>
                  }
                  @if (convertChangesToNumber(journey.changes) === 1) {
                    <span i18n="@@railResultsBlockChange">change</span>
                  }
                </div>
              }
              @if (convertChangesToNumber(journey.changes) === 0) {
                <div class="small_text" i18n="@@railResultsBlockDirect">Direct</div>
              }
              <button class="details_button" (click)="openDetailsModal(journey)">
                <span class="visuallyhidden">
                  Open details for journey departing {{ journey.from }} at
                  {{ journey.departDateTime | sabsTimePipe }} arriving at {{ journey.to }}
                  {{ journey.arriveDateTime | sabsTimePipe }}
                </span>
                <i class="currency_info_icon" aria-hidden="true"></i>
              </button>
            </div>
            <div id="{{ direction }}_arrival_time" class="table_header_main">
              {{ journey.arriveDateTime | sabsTimePipe }}
            </div>
          </div>
        </td>
        <td id="{{ direction }}_Co2" class="pc_display header_column">
          {{ journey.co2PerPassenger }}
          @if (journey.co2PerPassenger === lowestCarbonValue) {
            <img
              class="greenerChoiceLogo"
              src="https://images.sabscorp.com/images/logo/seedling.svg"
              alt="Carbon Efficient Fare"
            />
          }
        </td>
        <td class="header_column pc_display">
          <div class="flex-column-container">
            @if (busyTimes[journey.journeyHash]) {
              <section (mouseleave)="ttb.close()" class="container">
                <img
                  src="https://images.sabscorp.com/images/enterprise/lightUK/assets/png/busy_train.png"
                  alt="This service is predicted to be busy."
                  class="busy_train"
                  #ttb="ngbTooltip"
                  (mouseenter)="ttb.open()"
                  triggers="manual"
                  (focus)="ttb.open()"
                  (blur)="ttb.close()"
                  tabindex="0"
                  ngbTooltip="This service is predicted to be busy."
                  tooltipClass="button_tooltip"
                  i18n-ngbTooltip
                />
              </section>
            }
            @if (checkForBus(journey)) {
              <section (mouseleave)="ttbus.close()" class="container">
                <i
                  class="ico-bus replacement_bus"
                  alt="This is a bus replacement service."
                  #ttbus="ngbTooltip"
                  (mouseenter)="ttbus.open()"
                  triggers="manual"
                  (focus)="ttbus.open()"
                  (blur)="ttbus.close()"
                  tabindex="0"
                  ngbTooltip="This is a bus replacement service."
                  tooltipClass="button_tooltip"
                  i18n-ngbTooltip
                ></i>
              </section>
            }
            @if (journey.overtaken) {
              <span class="overtaken" i18n="@@railresultsheaderOvertaken">Overtaken </span>
            }
            @if (journey.cancelled) {
              <span class="cancelled" i18n="@@railresultsheaderCancelled">Service Cancelled </span>
            }
            @if (
              !busyTimes[journey.journeyHash] &&
              !checkForBus(journey) &&
              !journey.overtaken &&
              !journey.cancelled
            ) {
              <span class="visuallyhidden"> No additional information available </span>
            }
          </div>
        </td>
        @if (displayStandardSingles) {
          <td>
            @if (newResultsObject.standardSingles[journey.journeyHash]; as ticket) {
              <ng-container
                [ngTemplateOutlet]="
                  unavailableJourneysDueToTime[journey.journeyHash]
                    ? incompatible_button
                    : ticket.selectable && (!ticket.unavailable || canOverride)
                      ? button
                      : disabled_button
                "
                [ngTemplateOutletContext]="{
                  ticket,
                  journey,
                  ticketType: getTicketType(journey, ticket)
                }"
              ></ng-container>
            }
          </td>
        }
        @if (displayFirstClassSingles) {
          <td>
            @if (newResultsObject.firstClassSingles[journey.journeyHash]; as ticket) {
              <ng-container
                [ngTemplateOutlet]="
                  unavailableJourneysDueToTime[journey.journeyHash]
                    ? incompatible_button
                    : ticket.selectable && (!ticket.unavailable || canOverride)
                      ? button
                      : disabled_button
                "
                [ngTemplateOutletContext]="{
                  ticket,
                  journey,
                  ticketType: getTicketType(journey, ticket)
                }"
              ></ng-container>
            }
          </td>
        }
        @if (displayStandardReturns) {
          <td>
            @if (newResultsObject.standardReturns[journey.journeyHash]; as ticket) {
              <ng-container
                [ngTemplateOutlet]="
                  unavailableJourneysDueToTime[journey.journeyHash]
                    ? incompatible_button
                    : ticket.selectable && (!ticket.unavailable || canOverride)
                      ? button
                      : disabled_button
                "
                [ngTemplateOutletContext]="{
                  ticket,
                  journey,
                  ticketType: getTicketType(journey, ticket)
                }"
              ></ng-container>
            }
          </td>
        }
        @if (displayFirstClassReturns) {
          <td>
            @if (newResultsObject.firstClassReturns[journey.journeyHash]; as ticket) {
              <ng-container
                [ngTemplateOutlet]="
                  unavailableJourneysDueToTime[journey.journeyHash]
                    ? incompatible_button
                    : ticket.selectable && (!ticket.unavailable || canOverride)
                      ? button
                      : disabled_button
                "
                [ngTemplateOutletContext]="{
                  ticket,
                  journey,
                  ticketType: getTicketType(journey, ticket)
                }"
              ></ng-container>
            }
          </td>
        }
      </tr>
    }
  </tbody>
</table>
